import { useState, useCallback } from 'react';

export function useDialog(initialOpen = false) {
  const [open, setOpen] = useState(initialOpen);
  const [data, setData] = useState(null);

  const openDialog = useCallback((dialogData = null) => {
    setData(dialogData);
    setOpen(true);
  }, []);

  const closeDialog = useCallback(() => {
    setOpen(false);
    setData(null);
  }, []);

  const toggleDialog = useCallback(() => {
    setOpen(prev => !prev);
  }, []);

  return {
    open,
    data,
    openDialog,
    closeDialog,
    toggleDialog,
  };
}
